<template>
	<el-drawer
	  ref="drawer"
	  :with-header="false"
	  size="40%"
	  :visible.sync="dialogTableVisible"
	  direction="rtl"
	  v-loading="loading"
	  custom-class="demo-drawer"
	>
	    <el-form ref="dataForm" :model="dataForm" label-position="left" label-width="70px" style="width: 100%; padding:10px; height: 100vh;overflow-y: scroll;">
	       <el-tabs tab-position="top" style="height: 250px;">
			   <el-tab-pane tabIndex=-1 label="订单详情">
				    <div class="title">订单信息：</div>
					<div class="cons" style="display: flex;align-items: center;">
						状态：
						<span :style="{color:dataForm.status==0?'red':''}">
							{{dataForm.statusname}}
						</span>
						
						<el-button @click="zhifud()" type="success" size="mini" style="margin-left: auto;" v-if="dataForm.status==0 && types==0">
							立即支付
						</el-button>
					</div>
					<!--支付二维码-->
					<zhifu ref="zhifudata" @successpay="user_ghuanjing_detail()"></zhifu>
					
					<div class="cons" v-if="dataForm.status==1 || dataForm.status==2 || dataForm.status==3">
						支付时间：{{dataForm.payTime}}
					</div>
					<div class="cons">
					   环境名称：{{dataForm.huanjingname}}
					</div>
					<div class="cons">
						订单号：
						<span style="color: #ff4500;">
							{{dataForm.orderno}}
						</span>
					</div>
					<div class="cons">
						类型：{{dataForm.types==1?'个人':'组织'}}
					</div>
					<div class="cons" v-if="dataForm.yunxingtype==1">
						数据库算力价格：
						¥<span style="color: #ff4500;">{{dataForm.mysqlsuanli}}</span>元
					</div>
					<div class="cons" v-if="dataForm.yunxingtype==1">
						应用服务器算力价格：
						¥<span style="color: #ff4500;">{{dataForm.serversuanli}}</span>元
					</div>
					<div class="cons">
						总价：
						¥<span style="color: #ff4500;">{{dataForm.money}}</span>元
					</div>
					
				</el-tab-pane>
		   </el-tabs>
		</el-form>
    </el-drawer>
</template>

<script>
	import { user_ghuanjing_detail } from "@/api/huanjing"
	import zhifu from "../zhifu.vue"
	export default {
		components:{
			zhifu
		},
		data(){
			return{
				id:'',
				loading:false,
				dialogTableVisible:false,
				dataForm:{
					
				},
				types:0
			}
		},
		watch:{
			dialogTableVisible(e){
				if(e==false){
					this.dataForm = {}
					this.types = 0
					this.$emit("chenggong");
				}
			},
		},
		methods:{
			zhifud(){
				this.$refs.zhifudata.show(this.dataForm.id,this.dataForm.money,1)
			},
			user_ghuanjing_detail(){
				this.loading = true
				user_ghuanjing_detail({
					id:this.id
				}).then(res=>{
					this.loading = false
					console.log("运行资源申请",res.data);
					this.dataForm = res.data
				}).catch(()=>{
					this.loading = false
				})
			},
			handlecreate(id,types){
				this.dialogTableVisible = true
				this.id = id
				this.types = types?types:0
				this.user_ghuanjing_detail();
			},
		},
	}
</script>

<style lang="scss">
   .v-modal{
		z-index: 999!important;
	}
	.title{
		color: #ff4500;
		font-size: 16px;
		padding-bottom: 20px;
		font-weight: bold;
	}
	.cons{
		font-size: 14px;
		color: #333;
		padding-top: 10px;
		padding-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/components/shenqingdetail.vue